import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { Spinner } from '../Spinner/Spinner.js';
import S from './Button.styl.js';
import { focusOnClick } from './Button.helpers.js';

function Button(props) {
    const { className, loading, checked, square, onMouseUp, children, type = 'button', variant = 'default', size = 'm', prefixElem, postfixElem, ...rest } = props;
    const { disabled } = props;
    const classes = cn(S.root, S[`size-${size}`], S[`variant-${variant}`], loading && S.loading, checked && S.checked, square && S.square, className);
    const buttonRef = useRef(null);
    // @ts-ignore
    rest.onMouseUp = useCallback(e => {
        if (onMouseUp)
            onMouseUp(e);
        focusOnClick(buttonRef.current);
    }, [onMouseUp, buttonRef]);
    if (disabled)
        rest.tabIndex = -1;
    useEffect(() => {
        const activeElement = document.activeElement;
        if (!disabled || !activeElement)
            return;
        if (buttonRef?.current === activeElement)
            activeElement?.blur(); // eslint-disable-line
    }, [disabled]);
    return (
    // @ts-ignore
    jsxs("button", { className: classes, ...rest, type: type, ref: buttonRef, children: [prefixElem && jsx("div", { className: S.prefix, children: prefixElem }), typeof children === 'string' ? jsx("span", { children: children }) : children, postfixElem && jsx("div", { className: S.postfix, children: postfixElem }), loading && jsx(Spinner, { className: cn(S.spinner, S.postfix), size: size })] }));
}

export { Button };
